import { TDiscountTableDataCalculation } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const insertAdditionalDiscountServices = ({
  reservationId,
  payload,
}: {
  reservationId: string;
  payload: TDiscountTableDataCalculation;
}) => {
  return API.post(`api/accommodation/calculations/${reservationId}/discountServices`, payload);
};
